import { formatDate } from '@mi-front/core';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import StartSelectionIcon from '../../../../components/icon/custom/StartSelectionIcon';
import EndSelectionIcon from '../../../icon/custom/EndSelectionIcon';

const StyledStartEndWrapper = styled('span')(({ theme }) => ({
  display: 'flex',
  color: theme.palette.common.white,
  backgroundColor: '#92e1fe', // $color-AquaLight
  textAlign: 'center',
  height: '1.5rem',
  lineHeight: '1.5rem',
  fontSize: '0.75rem',
  borderRadius: '2px',
}));

const StyledIconWrapper = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.primary.main, // $color-Aqua
  padding: '0.25rem',
  '& svg path, & svg g': {
    fill: theme.palette.common.white,
  },
}));

const StyledStartIcon = styled(StyledIconWrapper)({
  marginRight: '0.15rem',
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
});

const StyledEndIcon = styled(StyledIconWrapper)({
  marginLeft: '0.15rem',
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px',
  marginRight: 0,
});

const StyledLabelText = styled('span')(({ theme }) => ({
  marginLeft: 'auto',
  width: '7rem',
  color: theme.palette.text.primary, // $color-Black
}));

interface Props {
  readonly ts: number;
  readonly isStart?: boolean;
  readonly isEnd?: boolean;
  readonly tz?: string;
}

export function StartEndLabel(p: Props) {
  return (
    <div className="d-inline-block">
      <StyledStartEndWrapper className={classNames('el-time-selection-label')}>
        {p.isStart && (
          <StyledStartIcon>
            <StartSelectionIcon size="1rem" />
          </StyledStartIcon>
        )}
        <StyledLabelText>{formatDate(p.ts, 'HH:mm:ss', p.tz)}</StyledLabelText>
        {p.isEnd && (
          <StyledEndIcon>
            <EndSelectionIcon size="1rem" />
          </StyledEndIcon>
        )}
      </StyledStartEndWrapper>
    </div>
  );
}
